import { useAuth } from "../Auth/Auth";
// import { LogoIcon, SchoolIcon } from "./Icons";
import { Layout, Space, Popconfirm, Button, Tooltip } from "antd";
// import { useCookies } from "react-cookie";
import { LogoutOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
const { Header } = Layout;

export const MainHeader = () => {
  const { user, removeUserLoginState } = useAuth();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // const [cookies, setCookie, removeCookie] = useCookies(["auth"]);
  const navigate = useNavigate();
  const confirm = () => {
    // removeCookie("auth");
    sessionStorage.removeItem("auth");
    removeUserLoginState();
    navigate("/");
    // window.location.replace(window.location.origin);
  };
  return (
    <Header
      id="iiscoreHeader"
      style={{ position: "fixed", zIndex: 1, width: "100%" }}
    >
      <div className="logo">
        {/* <SchoolIcon />
        <LogoIcon /> */}
        iiscore-U
      </div>
      <Space className="header-right-div" align="center">
        <span>{user.sei + user.mei} 様</span>
        <Popconfirm
          title="ログアウトしてもよろしいですか？"
          okText="はい"
          cancelText="いいえ"
          onConfirm={confirm}
          getPopupContainer={() => document.getElementById("iiscoreHeader")!}
        >
          <Tooltip title="ログアウト">
            <Button type="primary">
              <LogoutOutlined />
            </Button>
          </Tooltip>
        </Popconfirm>
      </Space>
    </Header>
  );
};
